<div
    id="candidate-results"
    class="page-layout simple"
>
    <!-- <mat-spinner
        color="accent"
        *ngIf="
            !loadingIndicator &&
            !this.campaignResultService.fetchedAll &&
            this.campaignResultService.isFetching
        "
        style="
            margin: auto;
            position: absolute;
            left: 40%;
            top: 40%;
            z-index: 999;
        "
    ></mat-spinner> -->
    <mat-spinner
        color="accent"
        *ngIf="isProcessing"
        style="
            margin: auto;
            position: absolute;
            left: 40%;
            top: 40%;
            z-index: 999;
        "
    ></mat-spinner>
    <div class="center">
        <mat-tab-group #tabGroup [(selectedIndex)]="defaultTabIndex">
            <mat-tab label="{{ 'CAMPAIGN.ROUND.ANNOUNCEMENT' | translate }}">
                <div
                    fxLayout="column"
                    class="mt-16"
                    fxLayoutGap="8px"
                    style="width: 70%; margin: auto"
                >
                    <mat-form-field
                        (click)="picker1.open()"
                        appearance="outline"
                        fxFlex="100"
                    >
                        <mat-label>{{
                            'CAMPAIGN.ROUND.ACCEPTING_DEADLINE' | translate
                        }}</mat-label>
                        <input
                            [min]="minDate"
                            [max]="maxDate"
                            [matDatepicker]="picker1"
                            matInput
                            [(ngModel)]="acceptingDeadline"
                            name="deadline"
                            [disabled]="!canSendResult"
                            [formControl]="deadlineControl"
                            readonly="true"
                            [required]="canSendResult"
                        />
                        <mat-datepicker-toggle [for]="picker1" matSuffix>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="100">
                        <mat-label>{{
                            'CAMPAIGN.ROUND.WORKPLACE' | translate
                        }}</mat-label>
                        <input
                            matInput
                            disabled="true"
                            class="mat-input"
                            type="text"
                            name="workingPlace"
                            placeholder="{{
                                'CAMPAIGN.ROUND.WORKPLACE' | translate
                            }}"
                            [(ngModel)]="workingPlace"
                        />
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="100">
                        <mat-label>{{
                            'CAMPAIGN.ROUND.GO_TO_WORK_NOTE' | translate
                        }}</mat-label>
                        <textarea
                            matInput
                            class="mat-input"
                            type="text"
                            name="goToWorkNote"
                            [rows]="5"
                            placeholder=""
                            [(ngModel)]="goToWorkNote"
                            [formControl]="goToWorkNoteControl"
                            required
                        ></textarea>
                    </mat-form-field>
                    <div fxLayout="row">
                        <table style="width: 100%">
                            <tr>
                                <td style="width: 150px">
                                    {{
                                        'CAMPAIGN.ROUND.OFFICIAL_COUNT'
                                            | translate
                                    }}:
                                </td>
                                <td>{{ countOfficial }}</td>
                            </tr>
                            <tr>
                                <td>
                                    {{
                                        'CAMPAIGN.ROUND.BACKUP_COUNT'
                                            | translate
                                    }}:
                                </td>
                                <td>{{ countBackup }}</td>
                            </tr>
                            <tr *ngIf="reviewerName">
                                <td>
                                    {{ 'CAMPAIGN.ROUND.REVIEWER' | translate }}:
                                </td>
                                <td>{{ reviewerName }}</td>
                            </tr>
                            <tr>
                                <td>
                                    {{ 'CAMPAIGN.ROUND.APPROVER' | translate }}:
                                </td>
                                <td>{{ approverName }}</td>
                            </tr>
                        </table>
                    </div>

                    <div
                        fxLayout="row"
                        fxFlex="auto"
                        fxLayoutAlign="end start"
                        class="mt-10"
                    >
                        <button
                            class="p-8 ml-4"
                            *ngIf="canSendResult"
                            (click)="openSendResultDialog()"
                            mat-raised-button
                            fxLayoutAlign="start center"
                            color="accent"
                            [disabled]="isProcessing"
                        >
                            <span class="text-uppercase">{{
                                'CAMPAIGN.ROUND.ANNOUNCEMENT' | translate
                            }}</span>
                        </button>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="{{ 'CAMPAIGN_RESULT.RESULT' | translate }}">
                <div fxLayout="column" style="height: calc(100vh - 157px); overflow: hidden">
                <div fxLayout="column" class="mt-10">
                    <div fxLayout="row" class="mt-8 pb-8 status-border-bottom">
                        <div fxFlex="40">
                            {{
                                'CAMPAIGN.ROUND.ACCEPTING_DEADLINE' | translate
                            }}:
                            {{ getTranslatedAcceptingDeadline() }}
                        </div>
                        <div fxFlex="20">
                            {{ 'CAMPAIGN.ROUND.ACCEPTED_COUNT' | translate }}:
                            {{ countAccept }}
                        </div>
                        <div fxFlex="20">
                            {{ 'CAMPAIGN.ROUND.OFFICIAL_COUNT' | translate }}:
                            {{ countOfficial }}
                        </div>
                        <div fxFlex="20">
                            {{ 'CAMPAIGN.ROUND.BACKUP_COUNT' | translate }}:
                            {{ countBackup }}
                        </div>
                    </div>

                    <div
                        class="multi-actions pt-8"
                        fxLayout="row"
                        fxLayoutAlign="start center"
                    >
                        <div fxLayoutAlign="start center">
                            <button
                                (click)="reloadResultTable()"
                                class="mr-8"
                                mat-raised-button
                                color="accent"
                                [disabled]="loadingIndicator"
                            >
                                <span>{{ 'COMMON.RELOAD' | translate }}</span>
                                <mat-icon class="ml-4">refresh</mat-icon>
                            </button>
                            <button
                                (click)="openSortResult()"
                                class="mr-8"
                                mat-raised-button
                                color="accent"
                                [disabled]="loadingIndicator"
                                *ngIf="canTakeAction"
                            >
                                <span>{{
                                        'CAMPAIGN.ROUND.RANK' | translate
                                    }}</span>
                            </button>
                        </div>
                        <div fxFlex="auto" fxLayoutAlign="start center">
                            <mat-form-field style="width: 400px" appearance='outline'>
                                <mat-label>{{ 'CAMPAIGN.ROUND.FIND_CANDIDATE' | translate }}</mat-label>
                                <input
                                    #searchInput
                                    matInput
                                    type="text"
                                    id="filter-campaign-result-text-box"
                                    placeholder="{{
                                        'CAMPAIGN.ROUND.FIND_CANDIDATE'
                                            | translate
                                    }}"
                                    (input)="onFilterTextBoxChanged($event)"
                                    [disabled]="loadingIndicator"
                                />
                            </mat-form-field>
                        </div>
                        <div fxFlex="490px">
                            <fw-campaign-result-selected-bar
                                *ngIf="canTakeAction"
                            >
                            </fw-campaign-result-selected-bar>
                        </div>
                    </div>
                </div>

                <app-campaign-result-table
                    fxFlex="auto"
                    #resultTableComponent
                    [loadingIndicator]="loadingIndicator"
                ></app-campaign-result-table>

                <div
                    *ngIf="!loadingIndicator"
                    fxLayout="row"
                    fxFlex="0 0 auto"
                    fxLayoutAlign="end start"
                    class="mt-10"
                >
                    <div fxFlex="auto" class="sort-status-container">
                        <p *ngIf="defaultTabIndex" class="sort-status-content">
                            {{ sortStatus }}
                        </p>
                    </div>

                    <button
                        *ngIf="canSubmitResult"
                        (click)="submitResult()"
                        mat-raised-button
                        color="accent"
                    >
                        <span class="text-uppercase">{{
                                'CAMPAIGN.ROUND.SEND_RESULT' | translate
                            }}</span>
                    </button>

                    <button
                        class="p-8 ml-4 mt-8"
                        *ngIf="canAccept"
                        (click)="openDenyPopup()"
                        mat-raised-button
                        fxLayoutAlign="start center"
                        color="warn"
                    >
                        <span class="text-uppercase">{{
                                'CAMPAIGN.ROUND.NOT_APPROVE' | translate
                            }}</span>
                    </button>

                    <button
                        class="p-8 ml-4 mt-8"
                        *ngIf="canAccept"
                        (click)="sendOtherSubmit()"
                        mat-raised-button
                        fxLayoutAlign="start center"
                        color="accent"
                    >
                        <span class="text-uppercase">{{
                                'CAMPAIGN.ROUND.APPROVE' | translate
                            }}</span>
                    </button>
                </div>
            </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
